import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PortalPageHeader } from "@/components/portal/PortalLayout";
import { StatBadge } from "@/components/admin/AdminLayout";

export default function FleetEarnings() {
  const [earnings, setEarnings] = useState(null);
  useEffect(() => { api.get("/fleet/earnings").then((r) => setEarnings(r.data)); }, []);
  if (!earnings) return <div className="p-10 text-slate-500">Loading…</div>;
  return (
    <div className="p-10 max-w-[1400px]">
      <PortalPageHeader eyebrow="Finance" title="Earnings" description="Your fleet commission on every paid trip. Calculated as % of the driver's earning, after DiTours platform fee." />
      <div className="grid grid-cols-3 gap-5 mb-8">
        <Kpi label="Total commission" value={`€${earnings.total.toFixed(2)}`} accent />
        <Kpi label="Paid trips" value={earnings.bookings_count} />
        <Kpi label="Avg commission" value={earnings.bookings_count ? `€${(earnings.total / earnings.bookings_count).toFixed(2)}` : "—"} />
      </div>
      <div className="bg-white border border-slate-200 shadow-sm">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200 text-left text-[10px] uppercase tracking-widest text-slate-500 font-semibold">
              <th className="p-4">Ref</th>
              <th className="p-4">Date</th>
              <th className="p-4">Client</th>
              <th className="p-4 text-right">Driver earning</th>
              <th className="p-4 text-right">Fleet commission</th>
              <th className="p-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {(earnings.bookings || []).length === 0 && <tr><td colSpan={6} className="p-10 text-center text-slate-500">No paid trips yet.</td></tr>}
            {(earnings.bookings || []).map((b) => (
              <tr key={b.id} className="border-b border-slate-100">
                <td className="p-4 font-mono text-[#f59e0b] text-xs">{b.reference}</td>
                <td className="p-4 text-xs text-slate-600">{new Date(b.service_datetime).toLocaleDateString()}</td>
                <td className="p-4 text-slate-700">{b.client_name}</td>
                <td className="p-4 text-right font-mono text-slate-700">€{(b.driver_earning || 0).toFixed(2)}</td>
                <td className="p-4 text-right font-mono text-[#f59e0b]">€{(b.fleet_commission || 0).toFixed(2)}</td>
                <td className="p-4"><StatBadge status={b.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
function Kpi({ label, value, accent }) {
  return (
    <div className={`bg-white border p-6 shadow-sm ${accent ? "border-[#f59e0b]" : "border-slate-200"}`}>
      <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold mb-3">{label}</div>
      <div className={`font-display text-3xl ${accent ? "text-[#f59e0b]" : "text-[#0a0f1e]"}`}>{value}</div>
    </div>
  );
}
